module.exports = __webpack_public_path__ + "static/media/Kigte64.6c8d167e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/EditorStudies/Kigte64.gif
// module id = 168
// module chunks = 0